import { Box } from "@mui/material";
import { theme } from "../../../styles/theme";
import { useCountdown } from "../../../hooks/useCountdown";

const Countdown = () => {
  const { remainingTime, hasTimeExpired } = useCountdown();

  return (
    <Box
      sx={{
        color: `${
          hasTimeExpired
            ? theme.palette.red.main
            : theme.palette.secondary.light
        }`,
        fontSize: "14px",
        textAlign: "center",
        paddingTop: "4px",
      }}
    >
      <Box as="span">
        {hasTimeExpired
          ? "Código de verificação expirado."
          : `Tempo de expiração: ${remainingTime.minutes}:${remainingTime.seconds} min`}
      </Box>
    </Box>
  );
};

export default Countdown;
